"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetGeoCode = exports.geoLocate = exports.successCallback = exports.setGeoLocation = exports.errorCallback = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var errorCallback = function errorCallback(err) {
  return err;
};

exports.errorCallback = errorCallback;

var setGeoLocation = function setGeoLocation(json, tabs) {
  if (json.results.length) {
    tabs.forEach(function (tab, i) {
      if (json.results[0].formatted_address.includes(tab.geocodeState)) {
        return i;
      }

      return 0;
    });
  }
};

exports.setGeoLocation = setGeoLocation;

var successCallback = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data, tabs, googleApiKey) {
    var url, res, json;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=".concat(data.coords.latitude, ",").concat(data.coords.longitude, "&key=").concat(googleApiKey);
            _context.next = 4;
            return window.fetch(url);

          case 4:
            res = _context.sent;
            _context.next = 7;
            return res.json();

          case 7:
            json = _context.sent;
            return _context.abrupt("return", setGeoLocation(json, tabs));

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", errorCallback(_context.t0));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function successCallback(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.successCallback = successCallback;

var geoLocate = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(tabs, googleApiKey) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!window.navigator.geolocation) {
              _context2.next = 3;
              break;
            }

            _context2.next = 3;
            return window.navigator.geolocation.getCurrentPosition(function (data) {
              return successCallback(data, tabs, googleApiKey);
            }, errorCallback, {
              enableHighAccuracy: true,
              maximumAge: 45000,
              timeout: 10000
            });

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function geoLocate(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

exports.geoLocate = geoLocate;

var useSetGeoCode = function useSetGeoCode(geocode, tabs, setTabValue, googleApiKey) {
  (0, _react.useEffect)(function () {
    (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var index;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return geoLocate(tabs, googleApiKey);

            case 2:
              index = _context3.sent;
              setTabValue(index || 0);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }, [geocode]);
};

exports.useSetGeoCode = useSetGeoCode;